document.addEventListener('click',function(event){const thumb=event.target.closest('[data-sb-image]');if(thumb){const main=document.getElementById('SbProductImage');if(main){event.preventDefault();main.src=thumb.href;main.removeAttribute('srcset');main.alt=thumb.dataset.alt||'';document.querySelectorAll('[data-sb-image]').forEach(el=>el.removeAttribute('aria-current'));thumb.setAttribute('aria-current','true');}}const menu=document.querySelector('.sb-mobile-menu');if(menu&&menu.open&&!menu.contains(event.target))menu.open=false;});document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.sb-mobile-menu');if(menu?.open){menu.open=false;menu.querySelector('summary').focus();}}});document.addEventListener('input',function(event){if(!event.target.matches('[data-sb-search]'))return;const term=event.target.value.toLocaleLowerCase().trim();let shown=0;document.querySelectorAll('.sb-faq-item').forEach(item=>{const match=item.textContent.toLocaleLowerCase().includes(term);item.hidden=!match;if(match)shown++;});const empty=document.querySelector('.sb-empty-search');if(empty)empty.hidden=shown>0;});

document.addEventListener('click',event=>{const ai=document.querySelector('.sb-ai-support');if(ai?.open&&(event.target.closest('[data-sb-close-ai]')||!ai.contains(event.target))){ai.open=false;if(event.target.closest('[data-sb-close-ai]'))ai.querySelector('summary').focus();}});document.addEventListener('keydown',event=>{const ai=document.querySelector('.sb-ai-support');if(event.key==='Escape'&&ai?.open){ai.open=false;ai.querySelector('summary').focus();}});

/* Product photo rotation; retains the existing gallery layout and thumbnail controls. */
(function () {
  function initGallery(scope) {
    const gallery = scope.querySelector('.sb-gallery');
    if (!gallery || gallery.dataset.sbAutoSlider) return;
    const main = gallery.querySelector('#SbProductImage');
    const thumbs = Array.from(gallery.querySelectorAll('[data-sb-image]'));
    if (!main || thumbs.length < 2) return;
    gallery.dataset.sbAutoSlider = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = thumbs.findIndex(thumb => new URL(thumb.href).pathname === new URL(main.currentSrc || main.src).pathname);
    if (index < 0) index = 0;
    let lastChange = Date.now();
    gallery.addEventListener('click', function (event) {
      const chosen = event.target.closest('[data-sb-image]');
      const chosenIndex = thumbs.indexOf(chosen);
      if (chosenIndex >= 0) {
        index = chosenIndex;
        lastChange = Date.now();
      }
    });
    const timer = window.setInterval(function () {
      if (!gallery.isConnected) {
        window.clearInterval(timer);
        return;
      }
      if (document.hidden || motion.matches || gallery.matches(':hover') || gallery.contains(document.activeElement) || Date.now() - lastChange < 4500) return;
      const nextIndex = (index + 1) % thumbs.length;
      const thumb = thumbs[nextIndex];
      main.src = thumb.href;
      main.removeAttribute('srcset');
      main.alt = thumb.dataset.alt || '';
      thumbs.forEach(item => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
      index = nextIndex;
      lastChange = Date.now();
    }, 4500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGallery(document); }, { once: true });
  } else {
    initGallery(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initGallery(event.target); });
})();
